module.exports = __webpack_public_path__ + "img/1fa96.efd8de2.svg";